import { useCallback } from 'react';

import createCustomEvent from './druid/utils/createCustomEvent';
import useReadTelemetryDimensions from '/druid/internal/useReadTelemetryDimensions';
import useWebChatAPIContext from '/druid/internal/useWebChatAPIContext';

export default function useTrackException(): (error: Error, fatal: boolean) => void {
  const { onTelemetry } = useWebChatAPIContext();
  const readTelemetryDimensions = useReadTelemetryDimensions();

  return useCallback(
    (error, fatal = true) => {
      if (!(error instanceof Error)) {
        return console.warn(
          'botframework-webchat: "error" passed to "useTrackException" must be specified and of type Error.'
        );
      }

      onTelemetry &&
        onTelemetry(
          createCustomEvent('exception', {
            dimensions: { ...readTelemetryDimensions() },
            error,
            fatal: !!fatal
          })
        );
    },
    [onTelemetry, readTelemetryDimensions]
  );
}
